export default __webpack_public_path__ + "fonts/right-nav.svg";